import React, { useEffect } from "react"
import Head from "next/head"
import AemGrid from "@/components/AemGrid"
import { loveYourLookDataUrl, footerUrl, headerUrl } from "@/constants"
import {
  getAemServerAxiosInstance,
  getAemServerModelJsonAxiosInstance,
} from "@/services/server/aem.server"
import { useDispatch } from "react-redux"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { i18n } from "next-i18next"
import { filterBackEndJson, getClienIP } from "@/utils/helper"
import ProductAccordion from "@/components/ProductDetail/v3/ProductAccordion"
import { setGbhDataLayerCustom } from "@/store/features/genericSlice"
import usePageAuth from "@/hooks/usePageAuth"
import { getDataLayerObj } from "@/utils/helper"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import BreadCrumb from "@/components/Default/BreadCrumb"
/**
 * renders home page
 * @return {JSX.Element}
 */
function Home({
  tmpData: data,
  headertmp: header,
  footertmp: footer,
  ip,
  globalScript,
  footerScript,
  analyticsData,
  gbhDataLayerCustom,
}) {
  const dispatch = useDispatch()
  useEffect(() => {
    if (ip) sessionStorage.setItem("true-ip", ip)
  }, [ip])
  usePageAuth()
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])
  useEffect(() => {
    dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => dispatch(setGbhDataLayerCustom(""))
  }, [])
  return (
    <>
      <Head>
        <title>{data?.title}</title>
        <meta name="keywords" content="Kohler US Plumbing Bathroom Kitchen" />
        <meta name="description" content={data?.description} />
        <meta property="og:title" content={data?.title} />
        <meta property="og:description" content={data?.description} />
        <meta property="og:url" content="/en" />
        <meta property="og:type" content={data?.templateName} />
      </Head>
      <>
        <GlobalPageHeader
          themeType={data?.appliedCssClassNames}
          header={header}
          title={data.title}
          globalScripting={globalScript}
          data={data}
        />
        <AemGrid
          data={data}
          count={0}
          breadCrumb={(data, fullData) => (
            <BreadCrumb data={data} fullData={fullData} />
          )}
          productAccordion={(data, fullData) => (
            <ProductAccordion data={data} fullData={fullData} />
          )}
        />
        <GlobalPageFooter footer={footer} footerScripting={footerScript} />
      </>
    </>
  )
}

/**
 *
 * @return {Object}
 */
export async function getServerSideProps({ req, res, locale }) {
  await i18n?.reloadResources()
  const serverAemApi = getAemServerAxiosInstance()
  const serverAemModelJsonApi = getAemServerModelJsonAxiosInstance()
  const ip = getClienIP(req)
  const urlPath = req.url.split("?")[0] ?? ""
  const { data } = await serverAemModelJsonApi({
    url: loveYourLookDataUrl,
    method: "GET",
  })
  const { data: header } = await serverAemApi({
    url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
    method: "GET",
  })
  const { data: footer } = await serverAemApi({
    url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
    method: "GET",
  })
  const globalScript = data?.globalScript ? data?.globalScript : null
  const footerScript = data?.footerScript ? data?.footerScript : null
  const topHeadScript = data?.topHeadScript ? data?.topHeadScript : null
  const analyticsScriptClass = data?.analyticsScriptClass
    ? data?.analyticsScriptClass
    : null
  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  const analyticsData = data?.data ? data?.data : null
  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
  }
  tmpData = filterBackEndJson(tmpData)
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  const metaContent = data?.metaContent ?? ""
  const canonicalUrl = data?.canonicalUrl ?? ""
  // Pass data to the page via props
  return {
    props: {
      ip,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      topHeadScript,
      analyticsData,
      analyticsScriptClass,
      gbhDataLayerCustom,
      urlPath,
      metaContent,
      canonicalUrl,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}
export default Home
